import CoverPageComponent from '../../../Containers/CoverPage/CoverPageComponent';
import FooterPageComponent from '../../../Containers/FooterPage/FooterPageComponent';
import OptionDetailsPageComponent from '../../../Containers/OptionDetailsPage/OptionDetailsPageComponent';
import TablePagesComponent from '../../../Containers/TablePage/TablePagesComponent';
import ErrorBoundary from '../../ErrorBoundary/ErrorBoundary';

import './PresentationPDFComponent.css';

function PresentationPDFComponent(props) {
  return (
    <>
      <ErrorBoundary>
        <div id="page1">
          <CoverPageComponent />
          <TablePagesComponent />
        </div>

        <OptionDetailsPageComponent />

        <div id="page4">
          <FooterPageComponent />
        </div>
      </ErrorBoundary>
    </>
  );
}

export default PresentationPDFComponent;
